// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> weidner-apartment-homes-theme-comfy -> the-alaskan
// Generated: 2026-11-02T18:12:21.649Z
// Counts: 0 design, 39 content, 18 slot group, 0 collection binding, 7 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Cozy Studio and One Bedroom Apartments</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome To <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Live Near Anchorage Landmarks</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Midtown Living</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1><h1></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover a blend of in-home comforts and community conveniences at The Alaskan. Studio and one-bedroom apartments offer built-in office desks, ceiling fans, and vaulted ceilings in select homes. Community amenities include an on-site laundry room, spaces for socializing, and an easy-to-use online portal. Whether you're working from home or relaxing outside, find the little details that make everyday living in Anchorage, AK, easier and more enjoyable.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We invite you to reach out to our friendly leasing team at The Alaskan Apartment Homes. Whether you have questions about floor plans, amenities, or scheduling a tour, our knowledgeable staff in Anchorage, AK, is here to help you every step of the way.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover thoughtfully designed floor plans at The Alaskan. Whether you choose a studio or a spacious one-bedroom, you'll enjoy flexible layouts for work-from-home days, extra storage, and built-in office desks in select homes. Many include kitchen essentials and airy touches, perfect for relaxing after a day in Midtown Anchorage.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Feel right at home with layouts that fit your Anchorage lifestyle, whether you need space for a home office or want a comfy retreat.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a peek at life at The Alaskan through our gallery. Bright living rooms, cozy kitchens, and welcoming bedrooms create a homelike feel. Lush lawns and mature trees surround the buildings, connecting you to the Midtown Anchorage neighborhood. Enjoy inviting social spaces and quiet corners perfect for unwinding after a busy day in Anchorage. Want more? Schedule a tour or explore our virtual options.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Alaskan is perfectly situated in Midtown Anchorage - close to both city highlights and natural escapes. Step outside and walk to Fairbanks Park or Chester Creek Sports Complex. The Seward Highway and public transit get you across town in minutes. Nearby, shop at Walmart Supercenter, Nordstrom, and Anchorage 5th Avenue Mall, plus dine at Jade Restaurant and Bernie’s Bungalow Lounge. For work or school, Elmendorf Air Force Base, Alaska Regional Hospital, and the University of Alaska at Anchorage are just a quick trip away. Enjoy active days and cozy nights from a relaxing home base in Anchorage, AK.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Connected to Midtown Anchorage</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Nestled near Delaney Park, Chester Creek Sports Complex, and vibrant dining and shopping, The Alaskan puts you close to Anchorage’s energy while offering relaxing spaces to unwind. Explore the Midtown neighborhood, shop at Carrs, visit the Anchorage Museum, or browse local shops at Anchorage 5th Avenue Mall. When you crave nature, Chester Creek and convenient trails are just steps away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Searching for apartments for rent in Anchorage, AK? At The Alaskan, you'll find comfortable studio and one-bedroom layouts designed to support your lifestyle, whether you work from home or spend your weekends outdoors. Enjoy a pet-friendly, smoke-free environment filled with in-home comforts and community spaces. Connect with neighbors at planned events or enjoy peaceful strolls to nearby Delaney Park and walking trails. Convenience and community come together at The Alaskan.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to see The Alaskan in person or online? Choose the tour style that fits your needs - in-person or virtual, guided by our knowledgeable team. Walk through our apartments, explore the picnic area and grill station, and picture life in Midtown Anchorage. Book a time that works for you and start imagining your next home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our virtual tour gives you a real feel for The Alaskan, right from your own screen. Walk through bright interiors with airy layouts, see sliding glass doors opening to private decks, and feel the open atmosphere. Plenty of closet and kitchen cabinet space shows how storage fits into everyday living. If you want to explore more or have questions, connect with our leasing team online for a personal walk-through. Get to know your next home in Anchorage, AK without leaving yours.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "customValue": "/apply-now",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "footer.get_in_touch_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "contact-hero.bg_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[4].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[4].image_media.alt_text"
      }
    }
  },
  "hero.feature_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021a-7912-74ff-bc77-d672924833a6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Clean kitchen with white cabinets, stove, dishwasher, and coffee maker."
      }
    }
  },
  "hero.feature_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021a-7895-75d5-a9c5-6f6da8ac771e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a queen-sized bed, nightstands, and a window view."
      }
    }
  },
  "hero.feature_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021a-8403-77d7-b08f-3a860b746201.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a dark wood-sided apartment building with white trim and balconies."
      }
    }
  },
  "hero.feature_slide_5": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "propertyoverview.card2_image": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021a-8403-77d7-b08f-3a860b746201.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a dark wood-sided apartment building with white trim and balconies."
      }
    }
  },
  "residentaccess.payrent_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021a-7912-74ff-bc77-d672924833a6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Clean kitchen with white cabinets, stove, dishwasher, and coffee maker."
      }
    }
  },
  "residentaccess.portal_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021a-7895-75d5-a9c5-6f6da8ac771e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a queen-sized bed, nightstands, and a window view."
      }
    }
  },
  "residentaccess.service_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021a-788d-74cb-baa8-deab72c70940.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright living room with a large sectional sofa, coffee table, and sliding glass door"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
